import splitbee from '@splitbee/web'

splitbee.init({
  // Cookie-less mode tradeoff:
  // - Upside: we don't need a cookie banner
  // - Downside: logged-out users aren't consistently identified, leading to them being tracked multiple times
  disableCookie: true,
  scriptUrl: '/bee.js',
  apiUrl: '/_hive',
})

export { splitbee }
